/**
 * description:
 * File of container Services Container
 *
 * data : 2017-08-03
 */

import Vue from 'vue';
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';
import _groupBy from 'lodash.groupby';
import moment from 'moment';

// COMPONENTS //////////////////////////////////////////////////////////////////
// eslint-disable-next-line import/extensions,import/no-unresolved
import RpcNotAvailable from '@/components/Services/RpcNotAvailable';
import ServiceCategory from '@/components/Services/ServiceCategory';
import ServiceCategoryTitle from '@/components/Services/ServiceCategoryTitle';
import ServiceBanner from '@/components/Services/ServiceBanner';
import FeatureTile from '@/components/Services/FeatureTile';
import CategoryLayout from '@/components/Help/CategoryLayout';
import SmartColumnLayout from '@/components/Help/SmartColumnLayout';
import { hDeepCopy } from '@/utils/helpers';
import { getMenuScheme, visibilityDependOnAcl } from '@/components/Panel/MenuCommon';
// CONTAINER ///////////////////////////////////////////////////////////////////
const Services = {
  components: { RpcNotAvailable, CategoryLayout, SmartColumnLayout, ServiceCategory, ServiceCategoryTitle, ServiceBanner, FeatureTile },
  store,
  data() {
    return {
      isRpcAvailable: true,
    };
  },
  computed: {
    ...mapGetters(['servicesList',
      'categoriesList',
      'servicesBanners',
      'hasServiceStatusBeenChange',
      'activationFailed',
      'subscriber',
      'pendingStoreActions',
      'responseCode',
      'servicesListLoading',
      'changeStatusLoading',
      'confirmationRequired',
      'enabled',
      'incorrect_code',
      'selectedCategory',
      'acl',
    ]),
    servicesByCategories() {
      let servicesList = this.servicesList.filter(service => service.changeable || service.rechargeable);
      let result = {};
      let categoriesCount = this.categoriesList.length;
      for (let i = 0; i < categoriesCount; i += 1) {
        result[this.categoriesList[i].name] = {
          name: this.categoriesList[i].name,
          icon: this.categoriesList[i].icon,
          order: this.categoriesList[i].order,
          internet: this.categoriesList[i].name.toLowerCase().indexOf('internet') >= 0,
          list: [],
        };
      }
      let servicesCount = servicesList.length;
      for (let i = 0; i < servicesCount; i += 1) {
        result[servicesList[i].category].list.push(servicesList[i]);
      }
      return result;
    },
    bannersFilter() {
      let sortedList = hDeepCopy(this.servicesBanners).sort((a, b) => a.order - b.order);
      let groupedByCategory = _groupBy(sortedList, 'services_categories_name');

      return groupedByCategory;
    },
    category() {
      if (this.servicesByCategories[this.selectedCategory]) {
        return this.servicesByCategories[this.selectedCategory];
      }
      return null;
    },
    isVisible() {
      return visibilityDependOnAcl(this, getMenuScheme()[3]);
    },
  },
  watch: {
    responseCode(newValue) {
      this.isRpcAvailable = true;
      if (newValue !== 200) {
        this.isRpcAvailable = false;
        this.$EventBus.$emit('Services/CLOSE_MODAL');
        const nowDate = moment();
        const stopDate = moment(nowDate).add(1, 'minutes');
        const data = {
          isBlocked: true,
          timestamp: stopDate,
        };
        localStorage.setItem('rpcAccess', JSON.stringify(data));
      }
    },
  },
  methods: {
    ...mapActions(['getServicesList', 'changeStatus', 'clearChangeStatusResult', 'getSizeLabels', 'getSizeValues']),
    async handleRefresh() {
      this.isRpcAvailable = true;
      await this.getServicesList();
            // eslint-disable-next-line eqeqeq
      if (this.responseCode == 200) {
        this.isRpcAvailable = true;
      } else {
        this.isRpcAvailable = false;
      }
    },
  },
  mounted() {

  },
  created() {
    if (localStorage.getItem('rpcAccess') === null) {
            // eslint-disable-next-line eqeqeq
      if (this.responseCode == 200) {
        this.getServicesList();
      }
    } else {
      this.isRpcAvailable = false;
    }
  },
  template: `
        <div class="container-fluid animated fadeIn modal-handler">
            <div class="Card__loading-container"
                 style="min-height: 100%;"
                 v-if="servicesListLoading || changeStatusLoading"
            >
                <div class="loading-container__loading-message">
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </div>
            </div>
            <div v-if="isRpcAvailable && isVisible">
                <div v-if="!category" class="mobile-content">
                    <ServiceCategoryTitle :title="'Internet'" v-if="!servicesListLoading"/>
                    <CategoryLayout v-if="!servicesListLoading">
                        <div slot="item"
                            v-for="[categoryName, serviceCategory] in Object.entries(servicesByCategories)"
                            v-if="serviceCategory.internet && serviceCategory.list.length"
                            class="CategoryLayout__item"
                            :class="{'CategoryLayout__item--hidden': false}"
                            :key="serviceCategory.name"
                        >
                            <ServiceCategory
                                :title="serviceCategory.name"
                                :icon="serviceCategory.icon"
                            />
                        </div>
                    </CategoryLayout>
                    <ServiceCategoryTitle :title="'Usługi i blokady'" v-if="!servicesListLoading" />
                    <CategoryLayout v-if="!servicesListLoading">
                        <div slot="item"
                            v-for="[categoryName, serviceCategory] in Object.entries(servicesByCategories)"
                            v-if="!serviceCategory.internet && serviceCategory.list.length"
                            class="CategoryLayout__item"
                            :class="{'CategoryLayout__item--hidden': false}"
                            :key="serviceCategory.name"
                        >
                            <ServiceCategory
                                :title="serviceCategory.name"
                                :icon="serviceCategory.icon"
                            />
                        </div>
                    </CategoryLayout>
                </div>
                <div class="mobile-content" v-else>
                    <ServiceCategoryTitle
                      :title="category.list[0].category_name"
                      :show_return="true"
                    />
                    <SmartColumnLayout>
                        <div slot="item" v-for="(service, index) in category.list">
                            <FeatureTile :service="service"/>
                        </div>
                        <div slot="item" v-for="(banner, index) in bannersFilter[selectedCategory]">
                            <ServiceBanner :banner="banner" />
                        </div>
                    </SmartColumnLayout>
                </div>
            </div>
            <div v-else>
              <RpcNotAvailable @refresh="handleRefresh"/>
            </div>
        </div>
    `,
};

export default Vue
    .component('Services', Services);



// WEBPACK FOOTER //
// ./src/containers/Services/index.js